import axios from 'axios';

export const FETCH_CALENDAR = 'FETCH_CALENDAR';

export function fetchCalendar(startDate, endDate) {
  return {
    type: FETCH_CALENDAR,
    payload: axios.get('/api/calendar.json?startDate=' + startDate + '&endDate=' + endDate),
  };
}
